import React from "react";
import Types from "prop-types";
import LanguageSelector from "../LanguageSelector";
import { fetchReCaptchaToken, ReCaptcha } from "../Guard";
import { Trans, withTranslation } from "react-i18next";
import { Redirect, withRouter } from "react-router-dom";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import { ARGUS_APM } from "../../apm";

class ChallengeFullName extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      submitting: false,
      passwordUpdatedDone: false,
      fullName: "",
      error: null,
    };
  }

  onChange(event) {
    this.setState({ fullName: event.target.value });
  }

  onSubmit(event) {
    event.preventDefault();
    this.setState({ submitting: true });

    let recaptchaPromise = fetchReCaptchaToken("forgot_password_email");

    recaptchaPromise
      .then((token) =>
        this.props.verifyChallenge({
          recaptcha: token,
          answer: this.state.fullName,
        })
      )
      .then(() =>
        this.setState({ submitting: false, passwordUpdatedDone: true })
      )
      .catch((err) => {
        ARGUS_APM.captureError(err);
        this.setState({
          submitting: false,
          passwordUpdatedDone: false,
          error: err.response?.data,
        });
      });
  }

  render() {
    const { t, challenge } = this.props;

    if (challenge == null) {
      return <Redirect to="/session_unknown" />;
    }

    const { error, passwordUpdatedDone, submitting } = this.state;
    if (passwordUpdatedDone) {
      return (
        <div>
          <CheckCircleOutlineIcon className="largeIcon successColor" />
          <h1>
            <Trans i18nKey="reset_password:reset_link_sent">
              A link to reset your password has been sent to you.
            </Trans>
          </h1>
          <div className="terms-text">
            <Trans i18nKey="reset_password:reset_password_instructions_message">
              Please check your email or SMS inbox for instructions to create a
              new password.
            </Trans>
          </div>
          <h3>
            <a href={process.env.REACT_APP_IDENTITY_REDIRECT}>
              <Trans i18nKey="reset_password:go_back_login">
                Go back to login.
              </Trans>
            </a>
          </h3>
        </div>
      );
    } else {
      return (
        <form onSubmit={this.onSubmit.bind(this)}>
          <LanguageSelector />
          <h1>{t("recover:forgot_password")}</h1>
          <h3>{t("recover:please_enter_full_name")}</h3>

          {error && (
            <div className="invalid show">
              {t(["error:" + error.message, "error:default"])}
            </div>
          )}

          <div className="material-form-field">
            <input
              type="text"
              autoFocus
              autoComplete="off"
              id="fullname"
              name="fullname"
              placeholder={challenge.hint.maskedFullName}
              dir={challenge.hint.dir}
              required
              onChange={this.onChange.bind(this)}
            />
            <label className="material-form-field-label" htmlFor="fullname">
              {t("recover:full_name")}
            </label>
          </div>

          <input
            className="btn-careem"
            type="submit"
            value={submitting ? t("common:please_wait") : t("common:continue")}
            name="verify-recover-btn"
            disabled={submitting}
          />

          <ReCaptcha />
        </form>
      );
    }
  }
}

ChallengeFullName.propTypes = {
  verifyChallenge: Types.func.isRequired,
  challenge: Types.object,
  t: Types.func.isRequired,
  history: Types.object.isRequired,
};

export default withRouter(withTranslation()(ChallengeFullName));
